import Vue from 'vue'
// import VueAnalytics from 'vue-ua'
import NProgress from 'nprogress'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  /* Usando o layout default */
  {
    path: '/',
    component: () => import('@/layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/pages/Home.vue'),
        children: [
          {
            path: '',
            name: 'Services',
            component: () =>
              import(
                /* webpackChunkName: "services" */ '@/components/home/Services.vue'
              )
          },
          {
            path: '/contactos',
            name: 'Contact',
            component: () =>
              import(
                /* webpackChunkName: "contacts" */ '@/components/home/Contact.vue'
              )
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (x, y) => ({ x: 0, y: 0 })
})

// Vue.use(VueAnalytics, {
//   trackPage: true,
//   vueRouter: router,
//   appVersion: '1.0.0',
//   appName: process.env.VUE_APP_GOOGLE_NAME,
//   trackingId: process.env.VUE_APP_GOOGLE_ANALYTICS
// })

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    NProgress.configure({ easing: 'ease', speed: 1000, showSpinner: false })
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
